import AwaitToJs from 'await-to-js';
export default AwaitToJs;